module.exports = __webpack_public_path__ + "static/media/web.3676c1f0.png";